import { meetsAxiosProtected as axios } from '../httpInstance/http'

export const getFeedbackQuestion = roomName => {
    return axios.get('/feedback/question/?room_name=' + roomName)
}

export const submitFeedback = feedback => {
    return axios.post(`/feedback/add/`, feedback)
}
